export const data =
{
    teksti: 'Pentti kiukustuu. Tajuat nyt, että olisi pitänyt teititellä ja muutenkin esittäytyä rauhassa eikä ruveta tivaamaan asiakkaan nimeä heti ensi töiksi. ',
    tarvittavaNoppaluku: 3,
    noppaMsg: "Heitä noppaa klikkaamalla nopan kuvaa. Elna saattaa leppyä, jos saat silmäluvuksi vähintään ",
    optiot: []
};



